export const CSRF_CONFIG = {
  COOKIE_NAME: 'zsn-csrf-token',
  HEADER_NAME: 'zsn-csrf-token',
};
